import { jsx as _jsx } from "react/jsx-runtime";
// TODO: implement when needed — Telegram chat ID, timezone, UI auto-refresh interval, default per-storage retention.
// The shape is decided in the spec (section 13 Settings paragraph) but not on the MVP critical path.
export function GeneralTab() {
    return (_jsx("div", { style: { color: 'var(--text-secondary)' }, children: "General settings \u2014 UI stub. Implement when needed." }));
}
